'use client'

import { AccountOutlineIcon } from '@/components/icons/AccountOutlineIcon'
import { GlobalNavMenuItems } from '@/components/layout/global/GlobalNavMenuItems'
import { GlobalPageHeader } from '@/components/layout/global/GlobalPageHeader'
import { HamburgerNavMenuItem } from '@/components/ui/HamburgerNavMenu'
import { LockScreenProvider } from '@/components/utils/LockScreenProvider'
import { cn } from '@/lib/utils'
import { PropsWithChildren, ReactNode } from 'react'
import { useLockScreen } from '@/components/layout/global/hooks/useLockScreen'

export type GlobalPageLayoutProps = PropsWithChildren<{
  navMenuItems?: ReactNode
  className?: string
  classNames?: { header?: string; lockscreen?: string }
}>

export function GlobalPageLayout({
  navMenuItems,
  className,
  children,
  classNames,
}: GlobalPageLayoutProps) {
  const [locked, setLock] = useLockScreen()
  const navItems = locked ? (
    <HamburgerNavMenuItem href="/sign-out" onClick={() => setLock(false)}>
      <AccountOutlineIcon className="h-6 w-6" />
      <p>Sign Out</p>
    </HamburgerNavMenuItem>
  ) : (
    (navMenuItems ?? <GlobalNavMenuItems />)
  )

  return (
    <div
      className={cn(
        'grid min-h-[100svh] grid-rows-[auto_1fr] bg-[#E6EAEF] dark:bg-black',
        className,
        locked && 'bg-white'
      )}
    >
      <GlobalPageHeader
        navMenuItems={navItems}
        className={cn('sticky inset-0 z-30', classNames?.header)}
      />
      <LockScreenProvider className={classNames?.lockscreen}>{children}</LockScreenProvider>
    </div>
  )
}
